/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */

import { BgImgHero, IconRow, TwoColTxtImg, IconEndlessScroll, StickyScroll, ImageColumns } from '../blocks';
import { AdvertisingForm } from '../forms/AdvertisingForm';
import { InputType } from '../../types';

export const AdvertisingPage = () => {
  return (
    <>
      <BgImgHero
        bgImg="/static/images/refresh/2025/ad-hero.jpg"
        content={[
          { title: 'Next-level experiences for <strong>next-gen audiences</strong>' },
          {
            bodyBase: 'Drive deeper connections with streaming audiences you can’t find anywhere else. Connect with our team to learn how you can leverage Xumo to reach your goals.',
            className: 'lg:mt-8 2xl:mt-10',
          },
          {
            ctaRow: [
              {
                href: '#contact',
                label: 'Get in touch',
                color: 'xumoAltBerryLight',
                light: true,
                primary: true
              }
            ],
          },
        ]}
        jointVenture={{
          img: '/static/images/refresh/2025/comcastxcharter.png',
          alt: 'Comcast and Charter',
        }}
      />
      <IconRow
        bg="#EFF3F5"
        title={[{ title: '<strong>Even more</strong> than FAST' }, { headingAlt: 'Xumo&apos;s innovating advertising, too' }]}
        icons={[
          {
            icon: '/static/images/refresh/2025/icon-star.svg',
            title: 'Modern TV operating system delivers incremantality',
            body: '115+ distribution partners and 5 major national retail partners',
          },
          {
            icon: '/static/images/refresh/2025/icon-tv-shows.svg',
            title: 'Premium content drives engagement',
            body: 'Nearly 400 channels from 350+ content partners and 70K titles on demand',
          },
          {
            icon: '/static/images/refresh/2025/icon-globe.svg',
            title: 'Global distribution unlocks scale',
            body: '2,000 channels powered by Xumo',
          },
        ]}
      />
      <TwoColTxtImg
        content={[
          { headingAlt: 'A total <strong>entertainment experience</strong>' },
          {
            bodyBase:
              'Xumo delivers simple streaming solutions backed by a joint venture formed by connectivity giants, Comcast and Charter. Our owned-and-operated devices and our FAST app help users connect with the content they love and advertisers connect with the audiences they’re looking for — the easy way.',
          },
        ]}
        image={{
          src: '/static/images/refresh/2025/total-entertainment-experience.png',
          alt: 'tv graphic',
          width: 1350,
          height: 802,
        }}
        reverse={false}
      />
      {/* <IconEndlessScroll
        bg="#EFF3F5"
        textbox={false}
        copy={[{ heading: 'Expand your reach <strong>even further</strong>' }]}
        icontabs={[
          {
            title: 'Content partners',
            icons: [
              [
                '/static/images/refresh/2025/content-partners/logo-nba.jpg',
                '/static/images/refresh/2025/content-partners/logo-nascar.jpg',
                '/static/images/refresh/2025/content-partners/logo-pga.jpg',
                '/static/images/refresh/2025/content-partners/logo-nfl.jpg',
                '/static/images/refresh/2025/content-partners/logo-big-12-studios.jpg',
                '/static/images/refresh/2025/content-partners/logo-us-open.jpg',
              ],
              [
                '/static/images/refresh/2025/content-partners/logo-filmrise.jpg',
                '/static/images/refresh/2025/content-partners/logo-bachelor-nation.jpg',
                '/static/images/refresh/2025/content-partners/logo-telemundo-accion.jpg',
                '/static/images/refresh/2025/content-partners/logo-snl-vault.jpg',
                '/static/images/refresh/2025/content-partners/logo-murder-she-wrote.jpg',
                '/static/images/refresh/2025/content-partners/logo-bravo-real-housewives-vault.jpg',
                '/static/images/refresh/2025/content-partners/logo-amc-thriller.jpg',
              ],
              [
                '/static/images/refresh/2025/content-partners/logo-tastemade.jpg',
                '/static/images/refresh/2025/content-partners/logo-test-kitchen.jpg',
                '/static/images/refresh/2025/content-partners/logo-antiques-road-trip.jpg',
                '/static/images/refresh/2025/content-partners/logo-design-network.jpg',
                '/static/images/refresh/2025/content-partners/logo-bbc-topgear.jpg',
              ],
            ],
          },
          {
            title: 'Distribution partners',
            icons: [
              [
                '/static/images/refresh/2025/distribution-partners/logo-lg-channels.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-roku-channel.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-google-tv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-amazon-fire-tv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-samsung-tv-plus.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-vizio.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-tivo.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-freevee.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-altice.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-vidaa.jpg',
              ],
              [
                '/static/images/refresh/2025/distribution-partners/logo-spectrum.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-xfinity.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-cox.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-rogers-xfinity.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-anoki.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-cw.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-dazn.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-directv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-dish.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-haystack-news.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-hisense.jpg',
              ],
              [
                '/static/images/refresh/2025/distribution-partners/logo-fubo-live.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-localnow.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-peacock.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-rakuten.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-sling.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-tubi.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-parrot-tv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-pluto-tv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-plex.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-tcl.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-tcl-tv.jpg',
                '/static/images/refresh/2025/distribution-partners/logo-xfinity-stream.jpg',
              ],
            ],
          },
        ]}
      /> */}
      <StickyScroll
        bg="#EFF3F5"
        flipped={false}
        textbox={true}
        alignText="center"
        itemWrapperClass="lg:-mb-[20vh] xl:-mb-[10vh]"
        sectionClass="pb-16 lg:pb-32"
        title={[
          { heading: '<strong>Access the largest network</strong> of connected TV households in the US', className: 'py-8 lg:pt-8 pb-16' },
          {subheadingAlt: 'Leverage Xumo’s exclusive inventory and meet our unique audiences.'}
        ]}
        content={[
          [
            { headingAlt: 'They’re watching <strong>Xumo channels</strong>' },
            {
              subheadingAlt: 'We power 2,000+ native FAST channels, programmed and distributed across OEMs and partners — some exclusively monetized by Xumo.',
            },
          ],
          [
            { headingAlt: 'They’ve got <strong>Xumo at home</strong>' },
            {
              subheadingAlt:
                'Our operating system powering Xumo TV and Xumo Stream Box is a modern streaming solution for the largest MVPDs in North America, replacing legacy video services with 10M+ devices in-market and 15+ distribution partners.',
            },
          ],
          [
            { headingAlt: 'They’re tuned in to <strong>Xumo Play </strong>' },
            {
              subheadingAlt:
                'Our FAST app is available on TVs, tablets, mobile devices and more, featuring premium content from 350+ channels and 70,000 titles on demand.',
            },
          ],
        ]}
        images={['/static/images/refresh/2025/xumo-channels.png', '/static/images/refresh/2025/xumo-at-home.png', '/static/images/refresh/2025/xumo-play.png']}
      />
      <ImageColumns
        title={[{ heading: 'Xumo <strong>advertising solutions</strong>' }]}
        columns={[
          {
            title: 'Scaled CTV video',
            body: 'Connect with highly engaged connected TV audiences across all platforms where Xumo powers channels and content.',
            image: '/static/images/refresh/2025/scaled-ctv-video.png',
          },
          {
            title: 'High-impact sponsorships',
            body: 'Make a lasting first impression with home screen messaging and capitalize on seasonal, brand-aligned moments.',
            image: '/static/images/refresh/2025/high-impact-sponsorship.png',
          },
          {
            title: 'Advanced ad formats',
            body: 'Boost engagement and drive conversions with innovative, advanced creative formats.',
            image: '/static/images/refresh/2025/advanced-ad-formats.png',
          },
        ]}
      />
      <TwoColTxtImg
        content={[
          { headingAlt: 'Advanced data activation' },
          {
            bodyBase:
              'Harness powerful audience data to optimize your advertising by activating first-party data, combining it with Xumo’s unique data and integrating third-party ecosystem identifiers.',
          },
        ]}
        image={{
          src: '/static/images/refresh/2025/advanced-data.png',
          alt: 'graphic',
          width: 1352,
          height: 1352
        }}
        flipped={false}
        imgpadding="70px"
      />
      <AdvertisingForm
        heading="<h3>Partner <strong>with us</strong></h3>"
        body="<p>Connect with our team to learn about how you can leverage Xumo’s inventory to meet new audiences and reach your goals.</p>"
        formFields={[
          {
            type: InputType.Name,
            name: 'first_name',
            placeholder: 'First name',
            width: 'third',
          },
          {
            type: InputType.Name,
            name: 'last_name',
            placeholder: 'Last name',
            width: 'third',
          },
          {
            type: InputType.Text,
            name: 'job_title',
            placeholder: 'Job title',
            width: 'third',
          },
          {
            type: InputType.Email,
            name: 'email',
            placeholder: 'Email',
            width: 'full',
          },
          {
            type: InputType.Name,
            name: 'company',
            placeholder: 'Company or agency name',
            width: 'half',
          },
          {
            type: InputType.Text,
            name: 'company_type',
            placeholder: 'Company type',
            width: 'half',
          },
          {
            type: InputType.Url,
            name: 'website_url',
            placeholder: 'Website URL',
            width: 'full',
          },
          {
            type: InputType.Text,
            name: 'representation',
            placeholder: 'If agency, what advertiser(s) do you represent?',
            width: 'full',
          },
          {
            type: InputType.Text,
            name: 'message',
            placeholder: 'How can we help with your next advertising campaign? ',
            width: 'full',
          },
        ]}
        CTA={{
          label: 'Submit',
          href: ' ',
        }}
        backgroundColor="#ffffff"
        headingOne={true}
        styleOverrides={{
          form: 'lg:mt-16',
          formField: 'rounded-none outline-1 outline-[#C2C2C2] placeholder:text-black',
          hideLabel: true,
          CTA: { alignment: 'w-full md:w-fit self-center mt-6' },
          accentColor: 'xumoAltBerryLight',
          hoverColor: 'xumoAltBerryDark',
        }}
      />
    </>
  );
};
